import {computed, observable} from "mobx";
import {Loadable} from "src/stores/table/LoadableStore";
import {INamedEntity, INamedEntityRpc, INamedEntitySelectRpc} from "src/stores/interfaces/INamedEntityRpc";

export class NamedEntitySelectStore<T> extends Loadable {
    @observable items? : INamedEntity<T>[];
    @observable selectedId : T | null;

    constructor(protected rpc: INamedEntitySelectRpc<T>, selectedId: T | null) {
        super();
        this.selectedId = selectedId;
    }

    @computed get selection() {
        return this.items?.find(x => x.id === this.selectedId);
    }

    async load(): Promise<void> {
        this.items = await this.rpc.getAll();
    }
}

export class NamedEntityCrudStore extends NamedEntitySelectStore<number> {
    constructor(rpc: INamedEntityRpc<number>, selectedId: number | null) {
        super(rpc, selectedId);
    }
    
    async selectNew() : Promise<void> {
        const id = await this.askToCreateNew();
        if (id != null)
            this.selectedId = id;
    }

    async askToCreateNew() : Promise<number | null> {
        const name = prompt("Enter name", "name");
        if(name == null)
            return null;
        const rpc = this.rpc as INamedEntityRpc<number>;
        const id = await rpc.create(name);
        this.items?.push({
            id: id,
            name: name
        });
        return id;
    }
}